export class TracingPlanStatus {
    id: number = 0;
    description: string = '';

    constructor() {        
    }
}